import React from 'react';
import { X, Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const rows = [{
  emoji: '⏰',
  without: 'Horas de entrenamiento sin dirección clara',
  with: 'Sistema progresivo desde el primer día'
}, {
  emoji: '😓',
  without: 'Siempre los mismos ejercicios → el juego no avanza',
  with: '80+ drills distintos → siempre hay progresión'
}, {
  emoji: '💸',
  without: 'Estancamiento que dura meses o años',
  with: 'Sistema de 5 pilares → evolución visible'
}, {
  emoji: '📋',
  without: 'Sin progresión clara de nivel a nivel',
  with: '6 tomos con progresión completa → mejorás y crecés'
}, {
  emoji: '😨',
  without: 'Momento crítico del partido = bloqueo mental',
  with: 'Protocolo mental → actuás con claridad y confianza'
}, {
  emoji: '👥',
  without: 'Técnica y táctica trabajadas por separado',
  with: 'Sistema integrado → todo ensamblado y funcionando'
}, {
  emoji: '📱',
  without: 'Sin desarrollo de liderazgo dentro del equipo',
  with: 'Tomo completo de comunicación y liderazgo'
}, {
  emoji: '💼',
  without: 'Sin identidad como armador élite',
  with: 'Sistema que te convierte en el director irremplazable del juego'
}];
export const CostComparison = () => {
  return <section className="py-12 md:py-24 bg-navy-950 border-t border-navy-800" data-id="element-44">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-45">
        <FadeIn className="text-center mb-8 md:mb-16" data-id="element-46">
          <h2 className="text-3xl md:text-6xl font-bebas text-white mb-4" data-id="element-47">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
          <div className="flex items-center justify-center gap-3" data-id="element-48">
            <div className="h-px w-12 bg-gold-500/40" data-id="element-49" />
            <span className="text-gold-500 text-sm uppercase tracking-widest" data-id="element-50">
              La diferencia es real
            </span>
            <div className="h-px w-12 bg-gold-500/40" data-id="element-51" />
          </div>
        </FadeIn>

        <FadeIn data-id="element-52">
          {/* Mobile: stacked card layout */}
          <div className="md:hidden space-y-3" data-id="element-53">
            {rows.map((row, i) => <div key={i} className="bg-navy-900 border border-navy-700 rounded-xl overflow-hidden" data-id="element-54">
                <div className="grid grid-cols-2 divide-x divide-navy-800" data-id="element-55">
                  <div className="p-3 bg-red-950/20" data-id="element-56">
                    <div className="flex items-center gap-1.5 mb-2" data-id="element-57">
                      <span className="text-base" data-id="element-58">{row.emoji}</span>
                      <X className="w-3.5 h-3.5 text-red-500" data-id="element-59" />
                    </div>
                    <div className="text-xs text-gray-400 leading-snug" data-id="element-60">
                      {row.without}
                    </div>
                  </div>
                  <div className="p-3 bg-gold-500/5" data-id="element-61">
                    <div className="flex items-center gap-1.5 mb-2" data-id="element-62">
                      <Check className="w-3.5 h-3.5 text-green-400" data-id="element-63" />
                      <span className="text-[10px] uppercase tracking-wider text-gold-500 font-bold" data-id="element-64">
                        Con Armador Élite
                      </span>
                    </div>
                    <div className="text-xs text-white leading-snug" data-id="element-65">
                      {row.with}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Desktop: table */}
          <div className="hidden md:block bg-navy-900 border border-navy-700 rounded-2xl overflow-hidden shadow-2xl" data-id="element-66">
            <table className="w-full border-collapse" data-id="element-67">
              <thead data-id="element-68">
                <tr className="bg-navy-950 border-b-2 border-navy-700" data-id="element-69">
                  <th className="text-left py-6 px-6 text-gray-400 font-bebas text-2xl w-1/2" data-id="element-70">
                    <span className="text-red-500 mr-2" data-id="element-71">✕</span> SIN ARMADOR DE
                    ÉLITE
                  </th>
                  <th className="text-left py-6 px-6 text-gold-500 font-bebas text-2xl w-1/2 bg-gold-500/5" data-id="element-72">
                    <span className="text-green-400 mr-2" data-id="element-73">✓</span> CON ARMADOR
                    DE ÉLITE
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-74">
                {rows.map((row, i) => <tr key={i} className={i < rows.length - 1 ? 'border-b border-navy-800' : ''} data-id="element-75">
                    <td className="py-4 px-6 text-gray-400" data-id="element-76">
                      <span className="mr-2" data-id="element-77">{row.emoji}</span> {row.without}
                    </td>
                    <td className="py-4 px-6 text-white bg-navy-800/30" data-id="element-78">
                      <div className="flex items-start gap-2" data-id="element-79">
                        <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-80" />{' '}
                        {row.with}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>
      </div>
    </section>;
};